<template>
  <!--
    Gestión de certificaciones para el cliente "solaring": tabs civil + mecánica +
    eléctrica. Los tres usan el panel unificado dirigido por entityType
    (1=civil, 2=mecánico, 3=eléctrico). El gateo por cliente lo hace la página contenedora;
    aquí solo se muestran los tabs cuya disciplina está CONFIGURADA en el proyecto
    (existe partner_processes de certificación para ese entity_type).
  -->
  <div>
    <b-tabs v-if="!isLoading && availableEntities.length" v-model="activeCertTab" class="epc-tabs">
      <!-- Tab civil (obra civil) -->
      <b-tab-item v-if="hasEntity(CERT_ENTITY.CIVIL)" :label="$t('certification_civil')">
        <certification-panel :project-id="project.id" :entity-type="CERT_ENTITY.CIVIL" />
      </b-tab-item>

      <!-- Tab mecánica (pictogramas) -->
      <b-tab-item v-if="hasEntity(CERT_ENTITY.MECHANICAL)" :label="$t('certification_mechanical')">
        <certification-panel :project-id="project.id" :entity-type="CERT_ENTITY.MECHANICAL" />
      </b-tab-item>

      <!-- Tab eléctrica (pictogramas) -->
      <!-- TODO(zanjas): si se necesita, añadir un 4º tab con el panel y docType 'trenches'
           (no existe backend para zanjas todavía). -->
      <b-tab-item v-if="hasEntity(CERT_ENTITY.ELECTRICAL)" :label="$t('certification_electrical')">
        <certification-panel :project-id="project.id" :entity-type="CERT_ENTITY.ELECTRICAL" />
      </b-tab-item>
    </b-tabs>

    <!-- Sin ninguna disciplina de certificación configurada en el proyecto. -->
    <p v-else-if="!isLoading" class="text-gray-500 py-6 text-center">
      {{ $t('no_results') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import CertificationPanel from '·/components/certifications/components/CertificationPanel.vue'
import { CERT_ENTITY } from '·/components/certifications/constants'

export default {
  name: 'CertificationManegeSolaring',

  components: {
    CertificationPanel,
  },

  data: () => ({
    activeCertTab: 0,
    // entity_type (civil/mecánico/eléctrico) con certificación configurada en el proyecto.
    availableEntities: [],
    isLoading: false,
    // Expuesto al template para usar nombres en vez de números mágicos.
    CERT_ENTITY,
  }),

  computed: {
    ...mapGetters({
      project: 'app/project',
    }),
  },

  created() {
    this.loadCertificationEntities()
  },

  methods: {
    hasEntity(entityType) {
      return this.availableEntities.includes(entityType)
    },

    async loadCertificationEntities() {
      if (!this.project || !this.project.id) {
        return
      }
      this.isLoading = true
      try {
        const { data } = await axios.get(`/api/v2/project/${this.project.id}/certification-entities`)
        this.availableEntities = (data && data.data) ? data.data.map(Number) : []
      } catch (e) {
        this.availableEntities = []
        this.$notify.error('error_loading_data')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
</style>
